export enum HandlingTypeEnum {
  PALLET = 'PALLET',
  PARCEL = 'PARCEL',
  CRATE_OF_WINE = 'CRATE_OF_WINE',
  BUNDLE = 'BUNDLE',
  CONTAINER = 'CONTAINER',
  ROLL = 'ROLL',
  // @deprecated
  INDIVISIBLE = 'INDIVISIBLE',
  // @deprecated
  PERSONALIZED = 'PERSONALIZED',
}
